import React, { useState } from 'react';
import styled from 'styled-components';
import RibbonItem from 'common/components/atoms/RibbonItem';
import InlineModal from 'common/components/molecules/InlineModal';
import OutsideAlerter from 'common/OutsideAlerter';
import PlusSvg from 'common/images/PlusSvg';
import { FlexContainer } from 'common/components/atoms';
import Button from 'common/components/atoms/Button';
import { ListIcon } from 'common/images/FaIcons';
import { useTranslation } from 'react-i18next';
import { MACHINE_LEVEL_ADD_OPTIONS } from '../constants/constants';


const Container = styled(FlexContainer)`
  align-items: center;
  z-index: ${props => props.zIndex ? props.zIndex : 1};
  /* Machine page: in flow inside the title bar. Analyze view: keep the old overlay. */
  position: ${props => (props.isAnalyzeView ? 'absolute' : 'relative')};
  ${props => props.isAnalyzeView && `
    top: 1.7em;
    right: 12em;
  `}
  ${Button} {
    margin: ${props => (props.isAnalyzeView ? '1em' : '0')};
  }
`;
const SummaryDropdown = ({ openModal, dropdownOptions, isAnalyzeView }) => {
  const { t } = useTranslation();
  const [dropdownMenuOpen, setDropdownMenuOpen] = useState(false);
  // In the title bar the add menu must open above page modals (z-index 999).
  const containerZIndex = isAnalyzeView ? 998 : 1000;

  return (
    <Container zIndex={containerZIndex} isAnalyzeView={isAnalyzeView}>
   { dropdownOptions && isAnalyzeView && (
      <div style={{ marginRight: '8px' }} onClick={() => setDropdownMenuOpen(prevState => !prevState)}>
      <ListIcon width={16} height={16} />
      </div>
   )}
   { !dropdownOptions && (
      <PlusSvg
        width={16}
        height={16}
        onClick={() => setDropdownMenuOpen(prevState => !prevState)}
        styled={{ padding: '10px' }}
      />
   )}
      {dropdownMenuOpen && (
        <InlineModal noOverlay minWidthInline="120px" marginTop="5px" noScroll close={() => setDropdownMenuOpen(false)}>
          <OutsideAlerter event="click" open handleClick={() => setDropdownMenuOpen(false)}>
            <div onClick={(e) => { setDropdownMenuOpen(false); e.stopPropagation(); }}>
            {dropdownOptions && (dropdownOptions.map((item, value) => (
                <RibbonItem
                  key={value}
                  fontSize="12.5px"
                  width="max-content"
                  onClick={() => openModal(item.value)}
                >
                  {item.textKey ? t(item.textKey) : item.text}
                </RibbonItem>
            )))}
              { !dropdownOptions && MACHINE_LEVEL_ADD_OPTIONS.map((item, idx) => (
                <RibbonItem
                  key={idx}
                  fontSize="14px"
                  width="max-content"
                  onClick={() => openModal(item.value)}
                >
                  {item.textKey ? t(item.textKey) : item.text}
                </RibbonItem>
              ))}
            </div>
          </OutsideAlerter>
        </InlineModal>
      )}
    </Container>
  );
};

export default SummaryDropdown;
